export const prepareFAQURL = () => {
  const url = `${__ENV_CONFIG__.__DEPOT__}/apis/v1/voyager_faqs/`;
  return url;
}

export const prepareMETAINFOURL = () => {
  const url = `${__ENV_CONFIG__.__VOYAGER__}/api/v1/pagemaker/get_rendered_template/?template_ids=["bus_home_page_meta"]`;
  return url;
}

export const prepareOfferURL = () => {
  const url = `${__ENV_CONFIG__.__VOYAGER__}/api/v1/pagemaker/get_personalized_chunk_offers_data/?chunk=home_carousel&vertical=bus&flavour=v3&include_fields=["url","img_url","sub_heading","validity_text","slug"]&mode=app`;
  return url
}

export const prepareHomeGoSafeBannerURL = () => {
  const url = `${__ENV_CONFIG__.__VOYAGER__}/api/v1/smart_engage/get_smart_ads/?context=gnr&flavour=v3&slots=["bus_dweb_home_gosafe"]&status=LIVE&vertical=bus`;
  return url;
}

export const rtcHomeBannerUrl = () => {
  const url = `${__ENV_CONFIG__.__VOYAGER__}/api/v1/pagemaker/get_rendered_template/?template_ids=["bus_rtc_banner_home_page"]`;
  return url;
}

export const busHomeCarouselUrl = () => {
  const url = `${__ENV_CONFIG__.__VOYAGER__}/api/v1/pagemaker/get_rendered_template/?template_ids=["bus_home_whats_new_carousel"]`;
  return url;
}